export default __webpack_public_path__ + "static/media/hrmtool.d7efc064.png";